var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgImages = function SvgImages(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 13,
    fill: "none",
    viewBox: "0 0 14 13"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.7 2.754h1.262v8.984h8.984V13H1.962c-.34 0-.64-.12-.901-.36a1.29 1.29 0 0 1-.36-.902V2.754ZM6.47 6.6 4.545 9.154h7.692L9.654 5.969 7.761 8.343 6.47 6.6Zm7.03 2.554c0 .34-.13.64-.39.901-.24.26-.531.391-.872.391H4.546c-.34 0-.64-.13-.901-.39-.26-.261-.39-.562-.39-.902V1.462c0-.34.13-.631.39-.871.26-.26.56-.391.901-.391h7.692c.34 0 .631.13.872.39.26.24.39.531.39.872v7.692Z"
  })));
};
var Memo = /*#__PURE__*/memo(SvgImages);
export default Memo;